export const FieldValidationRuleStates = {
    Correct: 'correct',
    Incorrect: 'incorrect',
};
export const ValidationChecklistTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components
    getValidationChecklistBase: () => 'validation-checklist',
    getValidationChecklistRuleItemBase: () => 'validation-rule',
    getValidationChecklistRuleItemFieldBase: (testId) => [
        ValidationChecklistTestIdFactory.getValidationChecklistRuleItemBase(),
        testId,
    ].join('-'),
    // For test id generation use
    getValidationChecklistListTestId: (testId) => [
        ValidationChecklistTestIdFactory.getValidationChecklistBase(),
        testId,
    ].join('-'),
    getValidationChecklistRuleItemTestId: (testId, index) => [
        ValidationChecklistTestIdFactory.getValidationChecklistRuleItemBase(),
        ValidationChecklistTestIdFactory.internalGenerateValidationChecklistRuleItemTestId(testId, index),
    ].join('-'),
    // internal -- do not use outside of component
    internalGenerateValidationChecklistRuleItemTestId: (testId, index) => [testId, index].join('-'),
    internalGetValidationChecklistRuleItemTestId: (testId) => [
        ValidationChecklistTestIdFactory.getValidationChecklistRuleItemBase(),
        testId,
    ].join('-'),
};
